import { Component } from '@angular/core';

@Component({
  selector: 'app-service-carousel',
  standalone: true,
  imports: [],
  templateUrl: './service-carousel.component.html',
  styleUrl: './service-carousel.component.css'
})
export class ServiceCarouselComponent {

}
